import React from 'react';
import { CheckCircle } from 'lucide-react';
export function WhyTrainHere() {
  const reasons = [{
    title: 'Structured Curriculum',
    description: 'Our training follows a clear, progressive curriculum designed to develop skills systematically over time.'
  }, {
    title: 'Consistent Standards',
    description: 'Every location maintains the same training standards, ensuring quality instruction wherever you train.'
  }, {
    title: 'Guided Development',
    description: 'Instructors provide personalized guidance and feedback to help each student progress at their own pace.'
  }, {
    title: 'Focused Training Environment',
    description: 'Classes are structured to maximize learning and skill development, not casual recreation or childcare.'
  }, {
    title: 'Long-Term Growth',
    description: 'Our programs are designed for sustained development, building both physical skills and mental discipline over time.'
  }, {
    title: 'Family-Oriented Community',
    description: 'We welcome students of all ages in an environment that emphasizes respect, discipline, and mutual support.'
  }];
  return <section className="relative py-20 border-y border-slate-800 overflow-hidden" data-id="element-346">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-347">
        <img src="https://cdn.magicpatterns.com/uploads/jPesdvQrTnMF6qJWinDVkQ/why-train.png" alt="Training Environment" className="w-full h-full object-cover" data-id="element-348" />
        {/* Dark overlay for readability */}
        <div className="absolute inset-0 bg-black/75" data-id="element-349"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-350">
        <div className="text-center mb-12" data-id="element-351">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 drop-shadow-lg" data-id="element-352">
            Why Train at Che Ko Martial Arts
          </h2>
          <p className="text-lg text-slate-200 max-w-2xl mx-auto drop-shadow-md" data-id="element-353">
            We provide a professional training environment where structure,
            consistency, and guidance create the foundation for real growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-354">
          {reasons.map((reason, index) => <div key={index} className="bg-white/95 backdrop-blur-sm rounded-lg p-6 border border-slate-200 shadow-sm" data-id="element-355">
              <div className="flex items-start" data-id="element-356">
                <div className="flex-shrink-0" data-id="element-357">
                  <CheckCircle className="h-6 w-6 text-[#dc2626]" data-id="element-358" />
                </div>
                <div className="ml-4" data-id="element-359">
                  <h3 className="text-base font-bold text-[#1a2332] mb-2" data-id="element-360">
                    {reason.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed" data-id="element-361">
                    {reason.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}